module.exports = require("d3-format");


/*****************
 ** WEBPACK FOOTER
 ** external "d3-format"
 ** module id = 18
 ** module chunks = 0
 **/